module.exports = __webpack_public_path__ + "img/otp.11ee09e2.png";